import {Outlet} from "react-router-dom";
import SiteHeader from "./SiteHeader";
import Footer from "./Footer";

export default function Layout() {
    return (
        <div style={{ minHeight: "100vh" }} className={"flex flex-col"}>
            <SiteHeader />
            <Outlet/>
            <Footer isVisibleMenu={true} />
        </div>
    );
}